<form [formGroup]="form" class="form flex-it flex-row flex-wrap">
  <div class="gutter details">Create a new workspace</div>

  <mat-form-field class="gutter flex-item-auto">
    <mat-label>Name</mat-label>
    <input matInput [formControlName]="LABEL" />
  </mat-form-field>
</form>

<div class="flex-it flex-row">
  <button
    mat-raised-button
    [disabled]="!form.valid"
    class="gutter flex-item-auto"
    color="primary"
    (click)="done()"
  >
    @if (!workspace) {
      <span>Create</span>
    }
    @if (workspace) {
      <span>Update</span>
    }
  </button>
  <button
    mat-stroked-button
    class="gutter flex-item-auto"
    color="warn"
    (click)="cancel()"
  >
    Cancel
  </button>
</div>
